import { render, staticRenderFns } from "./goodsTypeListAdd.vue?vue&type=template&id=a1e2f286&"
import script from "./goodsTypeListAdd.vue?vue&type=script&lang=js&"
export * from "./goodsTypeListAdd.vue?vue&type=script&lang=js&"
import style0 from "./goodsTypeListAdd.vue?vue&type=style&index=0&id=a1e2f286&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports